import { initializeAnalyticsClient } from './src/analytics-client';
export const analytics = initializeAnalyticsClient();
export * from './src/constants';
export {
  UNKNOWN_SCREEN,
  ANALYTICS_PRODUCT_DEFAULT,
  ANALYTICS_SUBPRODUCT_CASSI,
  ANALYTICS_SUBPRODUCT_ADV_CENTRAL,
  ANALYTICS_SUBPRODUCT_PARTNER_CENTRAL,
} from './src/analytics-client';
export { default as ScreenEventAnalytics } from './src/screen-event-analytics';
export * from './src/utils';
export * from './src/page-title-enums';
export { getEnvType } from './src/gas-analytics-client';
